export default __webpack_public_path__ + "images/small_deepecho_icon.8dc0174fc133b9b2fc406d35cdcfafc4.png";